import { createSlice } from "@reduxjs/toolkit";

const deviceSlice = createSlice({
  name: "device",
  initialState: {
    devices: [],
  },
  reducers: {
    setDevices: (state, action) => {
      state.devices = action.payload;
    },
  },
});

export const { setDevices } = deviceSlice.actions;
export default deviceSlice.reducer;
